import {v2Request} from "./v2Request";

export const userLevelConfigV2Api = {

  async findAll() {
    return v2Request.post(`userLevelConfig/findAll`)
  },

};
